import { AxiosResponse, AxiosError } from "axios";
import { useMutation } from "react-query";

import useAxios from "@src/config/axios/useAxios";
import { getEditSingleTestUrl } from "@src/config/baseUrls";

export type EditResultsModel = EditResultsFormValue[];

interface EditResultsFormValue {
  id: number;
  value?: number;
  notes?: string;
}

const defaultGroupId = "default";

const useEditTestResults = (
  studyId: string,
  testId: string,
  studyGroupId: string | null,
  clearSnapshot?: boolean,
) => {
  const axios = useAxios();

  return useMutation<AxiosResponse<string>, AxiosError, EditResultsModel>(
    ["editResults", studyId, testId, clearSnapshot],
    (values) => {
      let url = getEditSingleTestUrl(studyId, testId, !!clearSnapshot);

      if (studyGroupId !== null && studyGroupId !== defaultGroupId) {
        url += `&studyGroupId=${studyGroupId}`;
      }

      return axios.put(url, values);
    },
  );
};

export default useEditTestResults;
